module.exports = __webpack_public_path__ + "img/QQ30S.png";